import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EntitlementsModule } from '@backbase/foundation-ang/entitlements';
import { RetailLayoutModule } from '@backbase/retail/feature/layout';
import { HeaderModule } from '@backbase/ui-ang/header';
import { IconModule } from '@backbase/ui-ang/icon';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsCommunication } from '../communication/notifications-communication.service';
import { LayoutComponent } from './layout.component';
import { NavigationMenuComponent } from './navigation-menu/navigation-menu.component';
import { ButtonModule } from '@backbase/ui-ang/button';
import { BadgeCounterModule } from '@backbase/ui-ang/badge-counter';
import { AlertModule } from '@backbase/ui-ang/alert';
import { SbkFeatureFeatureFlagsAndLimitsModule } from '@sbk/feature/feature-flags-and-limits';
import { LoadingIndicatorModule } from '@backbase/ui-ang/loading-indicator';
import { SbkFeatureBillPaymentsModule } from '@sbk/feature/bill-payments';
import { SbkFeatureLoansModule } from '@sbk/feature/loans';
import { SbkFeatureInvestModule } from '@sbk/feature/invest';
import { CollapsibleAccordionModule } from '@backbase/ui-ang/collapsible-accordion';
import { CollapsibleCardModule } from '@backbase/ui-ang/collapsible-card';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RtcClientModule } from '@backbase/real-time-communication-journey-ang';
import { SbkSharedModule } from '@sbk/shared';

@NgModule({
  imports: [
    ButtonModule,
    BadgeCounterModule,
    CommonModule,
    RouterModule,
    HeaderModule,
    IconModule,
    NgbDropdownModule,
    EntitlementsModule,
    RtcClientModule,
    SbkFeatureFeatureFlagsAndLimitsModule,
    SbkFeatureBillPaymentsModule,
    SbkFeatureLoansModule,
    SbkFeatureInvestModule,
    SbkSharedModule,
    AlertModule,
    RetailLayoutModule.forRoot(NotificationsCommunication),
    LoadingIndicatorModule,
    CollapsibleAccordionModule,
    CollapsibleCardModule,
    BrowserAnimationsModule,
  ],
  exports: [LayoutComponent],
  declarations: [LayoutComponent, NavigationMenuComponent]
})
export class LayoutModule { }
